import { useNavigate } from 'react-router-dom'
import MuiButton from '@mui/material/Button'
import PageTitle from '../../components/page-title'
import ProspectsList from './components/prospectsList'

const Prospects = () => {
  const navigate = useNavigate()

  const onImportClick = () => {
    navigate('/prospects/imports')
  }

  const action = (
    <>
      <MuiButton variant="outlined" onClick={onImportClick}>
        Imports
      </MuiButton>
    </>
  )

  return (
    <div>
      <PageTitle title="Prospects" action={action} />
      <ProspectsList />
    </div>
  )
}

export default Prospects
